<template>
    <div class="sci__form">
        <div v-if="!admin" class="alert alert-primary">
            <!-- The Student Choice Initiative that was initiated for the 25-26 academic year has been cancelled by the
            provincial government. --> At King’s students are charged all ancillary fees automatically but have the
            opportunity to opt-out of the Orientation Week Fee (1st year) students and the King’s Endowment Fee.
            Select the fees you wish to opt out of below. To view the ancillary fees please <a
                href="https://www.kings.uwo.ca/current-students/money-matters/fees-and-responsibilities/schedules/"
                target="_blank" class="alert-link">click here</a>.
        </div>
        <form id="formSCI">
            <input type="hidden" name="version" id="version" value="1">
            <input v-if="user.record.recordID" type="hidden" name="recordID" id="recordID"
                :value="user.record.recordID">
            <form-kings-student :userData="user.record" :submitted="submitted" :admin="admin"
                @getKingsStudentTotal="getKingsStudentTotal">
            </form-kings-student>
            <!-- <form-kucsc :userData="user.record" :submitted="submitted" :admin="admin" @getKucscTotal="getKucscTotal">
            </form-kucsc> -->
            <form-usc :userData="user.record" :submitted="submitted" :admin="admin" @getUscTotal="getUscTotal"
                :expiringFields="expiringFields"></form-usc>
            <!-- <form-western :userData="user.record" :submitted="submitted" :admin="admin"
                @getWesternTotal="getWesternTotal">
            </form-western> -->
            <div class="row" :class="[ total > 0 ? 'sci__fee' : 'sci__nofee', 'sci__total']">
                <div class="col-6 col-md-8">
                    Total Optional Fees
                </div>
                <div class="col-6 col-md-4">
                    $ {{ total }}
                </div>
            </div>
        </form>
        <div class="sci__notes">
            <h6>Important information:</h6>
            <ul>
                <li>*Includes HST</li>
            </ul>
        </div>
        <div class="sci__footer">
            <div v-if="user.type ==='admin'" class="sci__admin">
                <div class="sci__buttons">
                    <transition name="fade">
                        <h6 v-if="status==='success'" class="text-success font-weight-bold">
                            <i class="far fa-check"></i> Opt-Outs form has been submitted!
                        </h6>
                        <h6 v-else-if="status==='warning'" class="text-warning font-weight-bold">
                            <i class="far fa-info"></i> An error occured during the submission process. <b>Please
                                contact
                                your system administrator.</b>
                        </h6>
                    </transition>
                    <button type="button" ref="sciBtnSubmit" class="btn btn-sm btn-primary" @click="submitForm">
                        Submit <i v-if="!submit" class="far fa-share"></i>
                        <i v-else class="far fa-spinner fa-spin"></i>
                    </button>
                </div>
            </div>
            <div v-else class="sci__student">
                <div v-if="admin">
                    <transition name="fade">
                        <div v-if="status==='success'" class="text-right text-success font-weight-bold mb-2">
                            <i class="far fa-check"></i> Opt-Outs form has been successfully updated!
                        </div>
                        <div v-else-if="status==='warning'" class="text-right text-warning font-weight-bold mb-2">
                            <i class="far fa-info"></i> An unexpected issue occureding during the update. <b>Please
                                contact your system administrator.</b>
                        </div>
                    </transition>
                    <div class="sci__buttons">
                        <button type="button" ref="sciBtnSubmit" class="btn btn-sm btn-primary" @click="submitForm">
                            Submit <i v-if="!submit" class="far fa-share"></i>
                            <i v-else class="far fa-spinner fa-spin"></i></button>
                    </div>
                </div>
                <div v-else>
                    <div v-if="status==='success'" class="alert alert-success">
                        <p>
                            <i class="far fa-check"></i>

                            Thank you for completing the Opt-Outs process. Your opt-out selections have been received. Should you have any questions, please email <a class="alert-link"
                                href="mailto:studentfinance@kings.uwo.ca">studentfinance@kings.uwo.ca</a>.
                        </p>
                        <p class="font-weight-bold">
                            Please allow 2-3 weeks processing time for opt-out refunds to appear on your statement of
                            account.
                        </p>
                    </div>
                    <div v-else-if="status==='warning'" class="alert alert-warning">
                        <i class="far fa-info"></i> An unexpected issue occured during the submission of the Opt-Outs form. <b>Please contact Financial Student Services.</b>
                    </div>
                    <div v-else class="sci__buttons">
                        <button type="button" class="btn btn-sm btn-primary" data-toggle="modal"
                            data-target="#sciFormModal">
                            Submit <i v-if="!submit" class="far fa-share"></i>
                            <i v-else class="far fa-spinner fa-spin"></i>
                        </button>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="sciFormModal" tabindex="-1" role="dialog"
                        aria-labelledby="sciFormModalTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h6 class="modal-title" id="sciFormModalTitle">Confirm Opt-Out Fees</h6>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    You are about to submit your opt-out fees choices, confirm?
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                                        @click="submitForm">Confirm</button>
                                    <button type="button" class="btn btn-sm btn-secondary"
                                        data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormKingsStudent from './KingsStudent';
import FormKucsc from './Kucsc';
import FormUsc from './UscStudent';
import FormWestern from './Western';
import {
    setTimeout,
    clearInterval
} from 'timers';

export default {
    name: 'SCIform',
    components: {
        FormKingsStudent,
        FormKucsc,
        FormUsc,
        FormWestern
    },
    props: {
        admin: {
            type: Boolean
        },
        expiringFields: {
            type: Array
        },
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            kingsstudent: "0.00",
            kucsc: "0.00",
            usc: "0.00",
            western: "0.00",
            total: "0.00",
            status: '',
            submit: false,
            submitTimer: '',
            submitted: false
        }
    },
    methods: {
        getKingsStudentTotal(total) {
            // King's Student Optional Fees
            this.kingsstudent = total;
            this.getTotalFees();
        },
        getKucscTotal(total) {
            // KUCSC Optional Fees
            this.kucsc = total;
            this.getTotalFees();
        },
        getUscTotal(total) {
            // USC Student Optional Fees
            this.usc = total;
            this.getTotalFees();
        },
        getWesternTotal(total) {
            // Western Optional Fees
            this.western = total;
            this.getTotalFees();
        },
        getTotalFees() {
            // Total fees for all categories
            this.total =
                Number.parseFloat(this.kingsstudent) +
                Number.parseFloat(this.usc);
            // Number.parseFloat(this.kucsc) +
            // Number.parseFloat(this.western);

            // Currency conversion
            this.total = Number.parseFloat(this.total).toFixed(2);
        },
        submitForm() {
            const that = this;
            const formRef = document.getElementById('formSCI');
            const formData = new FormData(formRef);
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?sciFormSubmit';
            URL = URL.replace("HOSTNAME", location.hostname);

            // Student functionality
            if (this.user.type && this.user.type.match(/student/i)) {
                // Prevent multiple submissions
                if (this.user.record.result && !this.user.record.result.match(/^OK/i)) {
                    // Loader icon
                    this.submit = true;

                    // POST request form submit
                    fetch(URL, {
                            method: 'POST',
                            body: formData
                        })
                        .then(function (response) {
                            // Parse response to JSON
                            return response.json();
                        })
                        .then(function (json) {
                            if (json.result && json.result.match(/OK/i)) {
                                // Success alert
                                that.status = 'success';
                                that.submitted = true;
                                that.submit = false;
                            } else {
                                // Warning alert
                                that.status = 'warning';
                                that.submit = false;
                            }
                        })
                        .catch(function () {
                            // Warning alert
                            that.status = 'warning';
                            that.submit = false;
                        })
                } else {
                    console.log('Nice try!');
                    return false;
                }

            } else {
                // Set loader bool
                this.submit = true;

                // Admin functionality
                fetch(URL, {
                        method: 'POST',
                        body: formData
                    })
                    .then(function (response) {
                        // Parse response to JSON
                        return response.json();
                    })
                    .then(function (json) {
                        if (json.result && json.result.match(/OK/i)) {
                            // Success alert
                            that.status = 'success';
                            that.submit = false;
                        } else {
                            // Warning alert
                            that.status = 'warning';
                            that.submit = false;
                        }
                    })
                    .catch(function () {
                        // Warning alert
                        that.status = 'warning';
                        that.submit = false;
                    })

                // Set timer
                if (!that.submitTimer) {
                    that.submitTimer = setTimeout(function () {
                        that.status = '';
                        clearInterval(that.submitTimer);
                    }, 5000);
                }
            }
        }
    },
    created() {
        // Handle form for students
        if (this.user.type && this.user.type.match(/student/i)) {
            // Check if student has submitted form
            if (this.user.record.result && this.user.record.result.match(/^OK/i)) {
                // Set status and message
                this.status = 'success';
                this.submitted = true;
            }
        }
    },
    mounted() {
        // Calculate total fees of all components and format to currency
        this.getTotalFees();
    }
}
</script>

<style>
a {
    color: #004ea2;
}

.alert-link {
    text-decoration: underline;
}

.fee__header {
    font-weight: 600;
}

.fee__info {
    color: #42484c;
    font-size: 12px;
}

.form__fee-check,
.form__fee-title,
.form__fee-value {
    border-bottom-color: rgba(0, 0, 0, .12);
    border-bottom-width: 1px;
    border-bottom-style: solid;
    height: 100%;
}

.form__fee-check-even,
.form__fee-title-even,
.form__fee-value-even {
    background: #eee;
    border-bottom-color: rgba(0, 0, 0, .12);
    border-bottom-width: 1px;
    border-bottom-style: solid;
    height: 100%;
}

.sci__buttons {
    text-align: right;
}

.sci__fee {
    color: #4b6a88;
}

.sci__nofee {
    color: #008040;
}

.sci__notes {
    margin-top: 1rem;
}

.sci__total {
    font-size: 16px;
    font-weight: 600;
}
</style>
